import { ProductCategory } from '@models';

export const CATEGORY_ZONE = 'zones';
export const CATEGORY_MENU = 'menu';

export const getZoneId = (totalCategories: ProductCategory[] | [] = []) =>
  totalCategories.filter((cat) => cat.parent_id === 0).find((cat) => cat.name.toLowerCase() === CATEGORY_ZONE)?.id;

export const getZones = (totalCategories: ProductCategory[]) => {
  const zoneId = getZoneId(totalCategories);

  return totalCategories.filter((cat) => cat.parent_id === zoneId);
};
